class ThemeSlider extends HTMLElement {
  labels = []; inputs; values; min; max; step;
  
  constructor() {
    super();
    this.init();
  }

  init = () => {
    // Se definiti, raccoglie gli elementi label dove mostrare i valori dello slider
    if(this.dataset.labels !== undefined){
      const labels = this.dataset.labels.split(',');
      labels.forEach(label => {
        const labelElement = document.querySelector(label);
        if(labelElement !== null){
          this.labels.push(labelElement);
        }
      });
    }

    this.inputs = this.querySelectorAll('input');
    const values = this.dataset.values.split(',');
    this.values = values.map(value => parseInt(value));

    this.min = parseInt(this.dataset.min);
    this.max = parseInt(this.dataset.max);
    this.step = this.dataset.step == undefined ? 1 : parseInt(this.dataset.step);
    
    // Crea uno slider noUiSlider a doppia maniglia (range) con i parametri specificati
    noUiSlider.create(this, {
      start: this.values,
      connect: true,
      range: {
        'min': this.min,
        'max': this.max
      },
      step: this.step
    });

    // 'update' viene triggerato durante il drag (per UI real-time)
    this.noUiSlider.on('update', (values) => {
      this.setValues(values);
    });

    // 'change' viene triggerato al rilascio (per salvataggio dati)
    this.noUiSlider.on('change', (values) => {
      this.setInputs(values);
      this.dispatchEvent(new CustomEvent(Utils.E_SLIDER_CHANGE, { detail: this.values }));
    });
  }

  setInputs = (values) => {
    this.values = values;
    this.inputs.forEach((input, index) => {
      input.value = this.values[index];
    });
  }

  setValues = (values) => {
    this.values = values;
    this.setLabels();
  }

  setLabels = () => {
    // Aggiorna gli elementi label con i valori formattati dello slider
    if(this.labels.length > 0){
      this.labels.forEach((label, index) => {
        label.innerHTML = this.format(this.values[index]);
      });
    }
  }

  format = (value) => {
    // Applica il formato specificato al valore
    // Se format='money', chiama Utils.money() per formattare come prezzo
    // Altrimenti rimpiazza il placeholder {label} con il valore
    const format = this.dataset.format || '{label}';
    if(format == 'money')
      return Utils.money(value);
    else
      return format.replaceAll('{label}', value);
  }
  
}
if (!window.customElements.get("theme-slider")) {
  window.customElements.define("theme-slider", ThemeSlider);
}